// extracted by mini-css-extract-plugin
export default {"container":"DashboardNav_container__J91S7"};